<template>
  <card>
    <template slot="header">
      <h4 class="card-title">Applications by Regions</h4>
      <p class="card-category"></p>
    </template>
    <div class="row">
      <div class="col-md-6 ml-auto mr-auto">
        <div class="table-responsive">
          <table class="table">
            <tbody>
            <tr>
              <td><strong>Region</strong></td>
              <td class="text-right"><strong>Applications</strong></td>
            </tr>
            <tr v-for="(region, index) in regions" :key="index">
              <td v-if="region.flag">
                <div class="flag">

                </div>
              </td>
              <td>{{region.name}}</td>
              <td class="text-right">{{region.total}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-6">
        <world-map style="height: 300px"></world-map>
      </div>
    </div>
  </card>
</template>
<script>
  import Loading from 'src/components/LoadingPanel.vue';

  const WorldMap = () => ({
    component: import('src/components/WorldMap/AsyncWorldMap.vue'),
    loading: Loading,
    delay: 200
  });
  export default {
    name: 'country-map-card',
    components: {
      WorldMap
    },
    props: {
      regions: Array
    }
  };
</script>
<style></style>
